import React, { Component } from 'react';
import { Button, Label, Switch, ButtonGroup } from 'app/components/Basics';
import { ButtonIcon } from '@ecosystem/ui-lib/core/components/ButtonIcon';
import { Icons } from '@ecosystem/ui-lib/core/components/Icon';
import { ReactComponent as PlusIcon } from 'app/assets/icons/Plus.svg';
import { Card } from '@ecosystem/ui-lib/core/components/Card';
import { Table, GenericCell } from '@ecosystem/ui-lib/core/components/Table';
import { Select } from '@ecosystem/ui-lib/core/components/Select';
import NewQuotaParameter from '../../models/QuotaParameterModel';
import NewQuotaParameterValue from '../../models/QuotaParameterValueModel';
import MultiSelect from 'app/components/MultiSelect';
import {QuotaFormContext} from '../../QuotaContext';
import { v4 as uuidv4 } from 'uuid';
import './TabParametersComponent.scss';

class TabParameters extends Component {
    constructor(props){
        super(props);
        this.state = {     
            errorQuotaText: '',
			showQuotaModal: false,			
			selectedQuotaToAdd: null
        }    
    }

	removeParameterHandler(parameterIndex) {
		var selectedQuota = this.context.selectedQuota;
		if (selectedQuota.parameters) {
			selectedQuota.parameters.splice(parameterIndex, 1);
            this.context.updateSelectedQuota(selectedQuota);
        }
	}	

	changeDemoQuestionHandler(parameterIndex, selectedItem) {
		var selectedQuota = this.context.selectedQuota;
		selectedQuota.parameters[parameterIndex].parameterValue.demoQuestionId = selectedItem.value;
		this.context.updateSelectedQuota(selectedQuota);
    }	

	getSelectedDemoQuestionOption(demoQuestionId) {
        return this.questionsToSelectBox().find(t=> t.value === demoQuestionId);
    }

	getSelectedQuestionAnswerOption(answerValue, parameterIndex, valueIndex) {	
		var selectedOption = this.questionOptionsToSelectBox(parameterIndex, valueIndex);
		if (selectedOption == null)	 return;
        return selectedOption.find(t=> t.value === answerValue);
    }

	getSelectedOptionsMultiSelect(metadata, selectedValues) {
		if (selectedValues == null)	return null;
		var result = [];		
		result = selectedValues.map(
			item => this.createOption(item, metadata)
		);		
		return result;
	}

	createOption(item, metadataList) {	
		if (!metadataList) { return null }
		return {
			value: item,
			label: metadataList.find(m=>m.value === item).label
		}
	}	

	questionsToSelectBox() {		
		return this.props.metadata.demoQuestions.map(function (q) {
			return { value: q.id.toString(), label: q.code + " - " + q.text }
		});
	}

	questionOptionsToSelectBox(parameterIndex) {		
		var questionId = this.context.selectedQuota.parameters[parameterIndex].parameterValue.demoQuestionId;		
		if (questionId == null) return null;
		var question = this.props.metadata.demoQuestions.find(q=>q.id === questionId);
		if (question == null) return null;
		return question.options.map(function (q) {
			return { value: q.value, label: q.text }
		});
	}

	changeRegionHandler(parameterIndex, selectedItem) {
		var selectedQuota = this.context.selectedQuota;
		selectedQuota.parameters[parameterIndex].parameterValue.regionCode = selectedItem.value;
		this.context.updateSelectedQuota(selectedQuota);
    }	

	getSelectedRegionOption(regionCode) {	
		return this.props.metadata.regions.find(q=>q.value === regionCode);		
    }

	isMatchSwitchHandler(index) {
		var selectedQuota = this.context.selectedQuota;
		this.context.selectedQuota.parameters[index].negate = !this.context.selectedQuota.parameters[index].negate;
		this.context.updateSelectedQuota(selectedQuota);
	}

	addParameterRow(parameter, rowIndex) {		
		if(parameter.tempKey == null) {
			parameter.tempKey = uuidv4();
		}
        return (
			<Card key={`${parameter.tempKey}_card`}>
				<div className="form-row">					
					<div className="form-row-right">
						<ButtonIcon onClick={() => this.removeParameterHandler(rowIndex)} icon={Icons.Close}/>
					</div>
				</div>
				<div className="form-row">
					<div className="form-row-left">						
						<div>					
							<ButtonGroup>
								<Button disabled={this.userCannotChangeData()} selected={this.context.selectedQuota.parameters[rowIndex].isDemoQuestionParam === true} onClick={this.onClickIsDemoQuestionParam.bind(this, rowIndex, true)} key="matchall" defaultActive >Demographic Question</Button>                                    
								<Button disabled={this.userCannotChangeData()} selected={this.context.selectedQuota.parameters[rowIndex].isDemoQuestionParam === false} onClick={this.onClickIsDemoQuestionParam.bind(this, rowIndex, false)} key="matchany" >Region</Button>
							</ButtonGroup>
						</div>
					</div>					
				</div>
				<Table
					className="QuotaList"
					columns={this.getParameterValuesTableColumns(rowIndex)}
					rows= {this.getParamValuesRows(parameter, rowIndex)}                
					sortingOptions={{headerKey: null}}
					isHeaderSticky={false}
					isFirstColumnSticky={false}
				/>
            </Card>)
    }

	getParamValuesRows(parameter, parameterIndex) {
		const rows = [];
        rows.push(this.addParameterValueRow(parameter.parameterValue, parameterIndex));        
		return rows;
	}

	getParameterValuesTableColumns(index) {
		var columns = [];
		columns.push(
			{   headerKey: `column-demoquestion`,
				className: "AppFormTableHeader column-demoquestion",
				name: this.context.selectedQuota.parameters[index].isDemoQuestionParam === true ? `Demo Question` : `Region`
			});
			columns.push({
				headerKey: `column-answer`,
				className: "AppFormTableHeader column-answer",
				name: this.context.selectedQuota.parameters[index].isDemoQuestionParam === true ? `Answer` : ``
			});	
			columns.push({
				headerKey: `column-negate`,
				className: "AppFormTableHeader column-remove",
				name: `Negate`
			});
		return columns;
	}

	addParameterValueRow(parameterValue, parameterIndex) {		
		if(parameterValue.tempKey == null) {
			parameterValue.tempKey = uuidv4();
		}
        const cols = [];
        cols.push(<GenericCell className="table-quota-param column-demoquestion" primary={<div>
			{this.context.selectedQuota.parameters[parameterIndex].isDemoQuestionParam === true && 
			(<Select name="sdemo" isSearchable={true}
				styles={{ option: styles => ({ minHeight: 40, ...styles }) }}                            
				onChange={val=>{this.changeDemoQuestionHandler(parameterIndex, val)}}							
				options={this.questionsToSelectBox()}
				value={this.getSelectedDemoQuestionOption(parameterValue.demoQuestionId)}
				isDisabled={this.userCannotChangeData()}
				key={`${parameterValue.tempKey}_sdemo`}
			/>)}
			{this.context.selectedQuota.parameters[parameterIndex].isDemoQuestionParam === false && 
			(<Select name="sregion" isSearchable={true}
				styles={{ option: styles => ({ minHeight: 40, ...styles }) }}                            
				onChange={val=>{this.changeRegionHandler(parameterIndex, val)}}							
				options={this.props.metadata.regions}
				value={this.getSelectedRegionOption(parameterValue.regionCode)}
				isDisabled={this.userCannotChangeData()}
				key={`${parameterValue.tempKey}_sregion`}
			/>)}
		</div>}/>);
		cols.push(<GenericCell className="table-quota-param column-answer" primary={<div>
			{this.context.selectedQuota.parameters[parameterIndex].isDemoQuestionParam === true && 
			(<MultiSelect isDisabled={this.userCannotChangeData()}
				selectedOptions={this.getSelectedOptionsMultiSelect(this.questionOptionsToSelectBox(parameterIndex), parameterValue.answerCodes)} 
				onChange={this.onChangeAnswer.bind(this, parameterIndex)} 
				onRemove={this.onRemoveAnswer.bind(this, parameterIndex)} 
				options={this.questionOptionsToSelectBox(parameterIndex)}
				showSelectAll={true}
				showSelectRange={true}>
			</MultiSelect>)}
			</div>		
		}/>);	
		cols.push(<GenericCell className="table-quota-param column-negate" primary={<div className="default-height centered">
			<Switch disabled={this.userCannotChangeData()} name="enabled" 
			setSwitchValue={this.isMatchSwitchHandler.bind(this, parameterIndex)} 
			checked={this.context.selectedQuota.parameters[parameterIndex].negate === true}/>
		</div>}/>);
        return cols;
    }

	onChangeAnswer(parameterIndex, items)  {		
		const selectedQuota = this.context.selectedQuota;
		selectedQuota.parameters[parameterIndex].parameterValue.answerCodes = [];
		selectedQuota.parameters[parameterIndex].parameterValue.answerCodes = items.map(x => x.value);
		this.context.updateSelectedQuota(selectedQuota);
	}

	onRemoveAnswer(parameterIndex, item)  {
		const selectedQuota = this.context.selectedQuota;
		selectedQuota.parameters[parameterIndex].parameterValue.answerCodes = selectedQuota.parameters[parameterIndex].parameterValue.answerCodes.filter(function(f) { return f !== item.value });
		this.context.updateSelectedQuota(selectedQuota);
	}

	addParameterHandler() {
		var selectedQuota = this.context.selectedQuota;
		var newParam = new NewQuotaParameter();
		newParam.parameterValue = NewQuotaParameterValue();
		selectedQuota.parameters.push(newParam);
		this.context.updateSelectedQuota(selectedQuota);
	}	

	onClickIsDemoQuestionParam(index, isDemoQuestionParam) {
		var selectedQuota = this.context.selectedQuota;
		selectedQuota.parameters[index].isDemoQuestionParam = isDemoQuestionParam;
		if (isDemoQuestionParam) {
			selectedQuota.parameters[index].parameterValue.regionCode = null;
		}
		else {
			selectedQuota.parameters[index].parameterValue.demoQuestionId = null;
			selectedQuota.parameters[index].parameterValue.answerCodes = [];
		}
		this.context.updateSelectedQuota(selectedQuota);
	}

	userCannotChangeData() {
		return !this.props.canChangeData;
	}
	
	getParameterRows() {
		const parameterRows = [];       
        this.context.selectedQuota.parameters.forEach((parameter, index) => {
            parameterRows.push(this.addParameterRow(parameter, index));
        });
		return parameterRows;
	}
	
	isAndSwitchHandler() {
		var selectedQuota = this.context.selectedQuota;
		selectedQuota.isAnd = !this.context.selectedQuota.isAnd;
		this.context.updateSelectedQuota(selectedQuota);
	}
	
    render() {	
		var parameterRows = this.getParameterRows();
        return (
            <div className="TabQuotaParameterComponent content-box">
                <div>
					<div className="form-row">
						<div className="form-row-left">						
							<div className="field-enabled">							
								<div className="default-height centered">								
									<ButtonGroup>
										<Button disabled={this.userCannotChangeData()} selected={this.context.selectedQuota.isAnd === true} onClick={this.isAndSwitchHandler.bind(this)} key="matchall" defaultActive >Match All</Button>                                    
										<Button disabled={this.userCannotChangeData()} selected={this.context.selectedQuota.isAnd === false} onClick={this.isAndSwitchHandler.bind(this)} key="matchany">Match Any</Button>
									</ButtonGroup>
								</div>
							</div>
						</div>
						<div className="form-row-right">
							<Button disabled={this.userCannotChangeData()} secondary icon={<PlusIcon/>} onClick={() => this.addParameterHandler()}>Parameter</Button>
						</div>
                	</div>
					
					{parameterRows}	

					<div style={{display: parameterRows && parameterRows.length > 0 ? 'none' : 'block' }}>
						<Card>
							<p className='EmptyQuotaListInfoTitle'>Parameters list is empty</p>
							<p className='EmptyQuotaListInfoText'>Please, add parameters via <span className='span-box'>+Parameter</span></p>
						</Card>
					</div>
                </div>
            </div>			
        );
    }
}
TabParameters.contextType = QuotaFormContext;
export default TabParameters;